import React from "react";
import { Search, Workflow, Plug, GraduationCap } from "lucide-react";
import "./Services.css";
import { useEffect } from "react";

const Services = () => {
  useEffect(() => {
    document.title = "AI Solutions by InnoRock – FAQ, Email, and Summary Agents";

    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Explore InnoRock's AI agents including FAQ chatbot, email assistant, and summary generator, all managed from a simple dashboard."
      );
    }

    const canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
      canonical.setAttribute(
        "href",
        "https://innorock.org/#serivces"
      );
    }
  }, []);

  const services = [
    {
      icon: <Search className="service-icon" />,
      title: "AI Readiness Audit",
      description:
        "Evaluate your company's AI potential and identify high-impact opportunities for automation and innovation.",
    },
    {
      icon: <Workflow className="service-icon" />,
      title: "Automation Consulting",
      description:
        "Build smart workflows and AI agents that streamline operations and eliminate repetitive tasks.",
    },
    {
      icon: <Plug className="service-icon" />,
      title: "Integration Setup",
      description:
        "Connect your existing tools with AI capabilities to create seamless, intelligent systems.",
    },
    {
      icon: <GraduationCap className="service-icon" />,
      title: "Training & Workshops",
      description:
        "Educate your team on AI adoption with hands-on training and practical implementation guidance.",
    },
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        {/* Header */}
        <div className="services-header">
          <h2>Our Services</h2>
          <p>
            Comprehensive AI consulting tailored to your business needs
          </p>
        </div>

        {/* Grid */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon-box">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
export { Services };
